import { values } from "lib";
import * as types from "./teamSignupTypes";

export const initState = {
  isProcessing: false,
  isSuccess: false,
  isOrganisationSucess: false,
  errors: {},
  personalOrganisation: null,
  user: null
};

const TeamSignupReducers = (state = initState, action) => {
  switch (action.type) {
    case types.PERSONAL_ORGANISATION_CREATE_REQUEST: {
      return {
        ...state,
        errors: {},
        isProcessing: true
      };
    }

    case types.PERSONAL_ORGANISATION_CREATE_REQUEST_SUCCESS: {
      const { users, organisations } = action.response.entities;

      return {
        ...state,
        isProcessing: false,
        isSuccess: true,
        personalOrganisation: values(organisations)[0],
        user: values(users)[0]
      };
    }

    case types.PERSONAL_ORGANISATION_CREATE_REQUEST_FAILURE: {
      const { error } = action;
      const validationErrors =
        error && typeof error === "object" && Array.isArray(error.errors)
          ? error.errors
          : null;

      let errorsMap;
      if (validationErrors) {
        errorsMap = validationErrors.reduce(
          (acc, err) => ({
            ...acc,
            [err.path]: err.message
          }),
          {}
        );
      } else {
        const generalMessage =
          (error && typeof error === "object" && error.message) ||
          (typeof error === "string" && error) ||
          "Sorry, something went wrong creating your account. Please try again.";
        errorsMap = { _general: generalMessage };
      }

      return {
        ...state,
        isProcessing: false,
        errors: errorsMap
      };
    }

    case types.ORGANISATION_CREATE_REQUEST_SUCCESS: {
      return {
        ...state,
        isOrganisationSucess: true,
        isProcessing: false
      };
    }

    case types.ORGANISATION_CREATE_REQUEST_FAILURE: {
      return {
        ...state,
        isOrganisationSucess: false,
        isProcessing: false
      };
    }

    case types.ORGANISATION_CREATE_REQUEST: {
      return {
        ...state,
        isProcessing: true
      };
    }
    default:
      return state;
  }
};

export default TeamSignupReducers;
